import axios from "@/config/axiosConfig";
import {
  CREATE_PURCHASE_BILL, DELETE_PURCHASE_BILL,
  GET_PURCHASE_BILLS,
  GET_PURCHASE_BILLS_PAGE,
  PURCHASE_BILL_REQUEST,
  PURCHASE_BILL_REQUEST_SUCCESS,
  PURCHASE_BILL_REQUEST_FAILURE,
  UPDATE_PURCHASE_BILL,
  GET_AVAILABLE_CHALLANS
} from "../types/purchase-bill-types";
import { Entry_Type } from "@/utils";

export const getPurchaseBillsWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_BILL_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Book_Id,Account_Id,Lot_Id'
      };
      return axios.get("/purchase-bill/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_PURCHASE_BILLS_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_BILL_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_BILL_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getPurchaseBills = (commonMaster, include, finyear) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_BILL_REQUEST });
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      let params = { finyearId: fin?.id, companyId: auth.company?.id };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/purchase-bill/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_PURCHASE_BILLS, payload: response.data?.data || [] });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_BILL_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_BILL_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getPurchaseBillsByRange = (bookId, billId, from, to, finyear) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      let params = {
        finyearId: fin?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        bookId, billId, from, to
      };
      
      const response = await axios.get("/purchase-bill/getAll", { params });
      return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getPurchaseAccountTurnover = (accountId, finyear) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      let params = {
        finyearId: fin?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        accountId: accountId
      };
      
      const response = await axios.get("/purchase-bill/get-account-turnover", { params });
      return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getPurchaseBillById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_BILL_REQUEST });
    
      return axios.get(`/purchase-bill/get/${id}`).then((response) => {
        dispatch({ type: PURCHASE_BILL_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_BILL_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_BILL_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const createPurchaseBill = (purchasebill, finyear) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      dispatch({ type: PURCHASE_BILL_REQUEST });
      const newPurchaseBill = {
        ...purchasebill
      };
      return axios.post("/purchase-bill/add", newPurchaseBill,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: fin?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_PURCHASE_BILL, payload: response.data });
        } else {
          dispatch({
            type: PURCHASE_BILL_REQUEST_FAILURE,
            error: "Purchase bill create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_BILL_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_BILL_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updatePurchaseBill = (id, data, finyear) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_BILL_REQUEST });
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      return axios.put("/purchase-bill/update", { id, data },
        { params: {
          userId: auth.user?.id,
          companyId: data.Company_Id || auth.company?.id,
          finyearId: data.Finyear_Id || fin?.id,
          customerId: data.Customer_Id || auth?.user?.Customer_Id,
        }}
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_PURCHASE_BILL,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: PURCHASE_BILL_REQUEST_FAILURE,
            error: "Purchase bill update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_BILL_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_BILL_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deletePurchaseBill = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_BILL_REQUEST });
      return axios.delete(`/purchase-bill/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_PURCHASE_BILL, id: id });
          const include = ['id', 'Entry_No', 'Invoice_No', 'Book_Id', 'Date', 'Account_Id', 'Order_No', 'Lot_Id', 'Amount', 'Net_Total'].join(',');
          const searchCols = ['Entry_No', 'Invoice_No'].join(',');
          const { inventory: { purchaseBill: { page, pageSize, search, where } = {} } } = getState();
          dispatch(getPurchaseBillsWithPagination(page, pageSize, include, search, searchCols, where, true));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_BILL_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_BILL_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getRemianingPurchaseOrders = (industryTypeId, id) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        customerId: auth?.user?.Customer_Id,
        industryTypeId,
        id
      };
      
      if (!auth?.company?.Common_Order) {
        params = { ...params, companyId: auth.company?.id }
      }

      return axios.get(`/purchase-bill/getRemainingOrders`, { params }).then((response) => {
        if (response.data) {
          return response.data;
        } else {
          return [];
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_BILL_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_BILL_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getRemianingPurchaseChallans = (accountId, date, id, finyear) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      let params = {
        finyearId: fin?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        accountId,
        date,
        id
      };
      return axios.get(`/purchase-bill/getRemainingChallans`, { params }).then((response) => {
        dispatch({ type: GET_AVAILABLE_CHALLANS, payload: response.data || [] });
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_BILL_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_BILL_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getPurchaseBillByInvoiceNo = (invNo, finyear) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      let params = {
        finyearId: fin?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        invoiceNo: invNo
      };
      return axios.get(`/purchase-bill/get-by-invoice-no`, { params }).then((response) => {
        return response?.data;
      }).catch((error) => {
        console.error(error); 
      });
    } catch (error) {
      console.error(error);
    }
  };
};

export const getPurchaseBillsListByInvoiceNo = (invNo) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        invoiceNo: invNo
      };
      return axios.get(`/purchase-bill/get-all-bills-by-invoice-no`, { params }).then((response) => {
        return response?.data;
      }).catch((error) => {
        console.error(error); 
      });
    } catch (error) {
      console.error(error);
    }
  };
};

export const getPaymentDetailsByPurchaseBillId = (id) => {
  return async (dispatch, getState) => {
    try {
      const params = {
        billId: id,
        billType: Entry_Type.PURCHASE_BILL
      };
      return axios.get(`/bill-adjustment/get-payment-detail-by-id`, { params })
        .then((response) => {
          return response?.data;
        }).catch((error) => {
          console.error(error);
          throw error;
        });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getRemianingPurchaseJobYarnReceives = (accountId, id, finyear) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      let params = {
        finyearId: fin?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        accountId,
        id
      };
      return axios.get(`/purchase-bill/available-job-yarn-receive`, { params }).then((response) => {
        if (response.data) {
          return response.data;
        } else {
          return [];
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_BILL_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_BILL_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getRemianingPurchaseGrayJobReceives = (accountId, id, finyear) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      let params = {
        finyearId: fin?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        accountId,
        id
      };
      return axios.get(`/purchase-bill/available-gray-job-receive`, { params }).then((response) => {
        if (response.data) {
          return response.data;
        } else {
          return [];
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_BILL_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_BILL_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getPurchaseOrderTrantionGradeWiseRateInPurchaseBill = (include) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {};
      if (!auth?.company?.Common_Master) {
        params = { ...params, companyId: auth.company?.id }
      }
      if (include) {
        params = { ...params, ...include };
      }
      return axios.get(`/purchase-bill/getAllPurchaseOrdersTransactionGradeWiseRate`, { params }).then((response) => {
        return response?.data;
      }).catch((error) => {
        console.error(error);
      });
    } catch (error) {
      console.error(error);
    }
  };
};